import { ReactElement } from 'react'
import { Autocomplete, SxProps, TextField, Theme } from '@mui/material'
import type { OrganisationDTO } from '@api/fastAPI.schemas'
import { organisationLabel } from '@utils'

interface OrganisationAutocompleteFieldProps {
  organisations: OrganisationDTO[]
  value: OrganisationDTO | null
  onChange: (organisation: OrganisationDTO | null) => void
  dataCy: string
  noOptionsText: string
  sx?: SxProps<Theme>
  error?: string
}

const OrganisationAutocompleteField = ({
  organisations,
  value,
  onChange,
  dataCy,
  noOptionsText,
  sx,
  error,
}: OrganisationAutocompleteFieldProps): ReactElement => (
  <Autocomplete
    sx={sx}
    options={organisations}
    value={value}
    onChange={(_, organisation) => onChange(organisation)}
    getOptionLabel={organisationLabel}
    isOptionEqualToValue={(option, currentValue) => option.guid === currentValue.guid}
    size="small"
    renderInput={params => (
      <TextField
        {...params}
        label="Organisation"
        data-cy={dataCy}
        error={Boolean(error)}
        helperText={error}
      />
    )}
    noOptionsText={noOptionsText}
  />
)

export default OrganisationAutocompleteField
